module.exports = __webpack_public_path__ + "static/media/bg-tent.1f17271c.jpg";